var map = {
	"./download.svg": "e3da",
	"./heart-empty.svg": "e31c",
	"./heart-red.svg": "df1a",
	"./minus.svg": "c461",
	"./pan.svg": "81f9",
	"./plus.svg": "2167",
	"./reset.svg": "f3f6",
	"./search.svg": "d481",
	"./share.svg": "8a24",
	"./user-circle.svg": "da63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caf4";